import { action, createRequestTypes } from 'utils/actions'

export const ENTITIES_SETTINGS = createRequestTypes('ENTITIES_SETTINGS')

export const settings = {
  request: () => action(ENTITIES_SETTINGS.REQUEST),
  success: response => action(ENTITIES_SETTINGS.SUCCESS, { response }),
  failure: error => action(ENTITIES_SETTINGS.FAILURE, { error }),
}



/** WEBPACK FOOTER **
 ** ./src/actions/entities/settings/settings-actions.js
 **/